module.exports = __webpack_public_path__ + "img/db_helvethaicaais_x_v3.2-webfont.a96b8c7b.svg";